import { render, staticRenderFns } from "./HomeAbout.vue?vue&type=template&id=547ddca1&scoped=true&"
var script = {}
import style0 from "./HomeAbout.vue?vue&type=style&index=0&id=547ddca1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547ddca1",
  null
  
)

export default component.exports